import React from "react";
import { XCircle, EyeOff } from "lucide-react";
import { BLOQUEIO, rotuloBloqueio } from "./statusPedidoAntigo";

// Selo sobre o mosaico do card "Peça de novo" — mesmo desenho do ESGOTADO dos
// cards do cardápio (véu escuro + pílula), pra ficar igual ao resto do sistema.
export default function SeloStatusPedido({ status }) {
  if (!status) return null;
  const esgotado = status.bloqueio === BLOQUEIO.ESGOTADO;
  const Icone = esgotado ? XCircle : EyeOff;
  return (
    <div
      className="absolute inset-0 bg-black/45 flex items-center justify-center"
      data-e2e="peca-de-novo-selo"
    >
      <span
        className={`text-[9px] font-black uppercase tracking-wider px-2 py-0.5 rounded-full text-white shadow-sm flex items-center gap-1 ${
          esgotado ? "bg-red-500" : "bg-zinc-700"
        }`}
      >
        <Icone className="w-3 h-3" /> {rotuloBloqueio(status)}
      </span>
    </div>
  );
}
